<template>
  <div
    class="input-radio-with-bullets"
    v-bind:class="`input-radio-with-bullets--${direction}`"
    role="group"
  >
    <template
      v-for="{
        checked,
        inputKey,
        labelKey,
        title,
        value,
      } in options"
    >
      <input
        class="input-radio-with-bullets__input"
        type="radio"
        v-bind:disabled="disabled"
        v-bind:checked="checked"
        v-bind:key="inputKey"
        v-bind:id="inputKey"
        v-bind:name="identifier"
        v-bind:value="value"
        v-on:input="onInput(value)">
      <label
        class="input-radio-with-bullets__title"
        v-bind:for="inputKey"
        v-bind:key="labelKey"
      >{{ title }}</label>
    </template>
  </div>
</template>
<script>
/**
 * @description Компонент замещаемого выбора с точками.
 * @type {Vue}
 */
export default {
  computed: {
    /**
     * @description Отображаемые опции.
     */
    options() {
      return this.items.map(({ title, value }) => ({
        checked: this.value === value,
        inputKey: `${this.identifier}:${value}:input`,
        labelKey: `${this.identifier}:${value}:label`,
        title,
        value,
      }));
    },
  },
  methods: {
    /**
     * @description Обработать выбор элемента.
     * @param {string} value
     * @returns {void}
     */
    onInput(value) {
      this.$emit('input', value);
    },
  },
  name: 'InputRadioWithBullets',
  props: {
    /**
     * @description Направление инпутов (column|row).
     * @type {Boolean}
     */
    direction: {
      type: String,
      default: () => 'column',
    },
    /**
     * @description Идентификатор опций.
     */
    identifier: {
      required: true,
      type: String,
    },
    /**
     * @description Возможные значения.
     */
    items: {
      required: true,
      type: Array,
    },
    /**
     * @description Допускается пустое значение.
     */
    optional: {
      default: () => false,
      type: Boolean,
    },
    /**
     * @description Значение.
     */
    value: {
      required: false,
      type: String,
      default: () => '',
    },
    /**
     * @description Выключен.
     * @type {Boolean}
     */
    disabled: {
      required: false,
      type: Boolean,
      default: () => false,
    },
  },
};
</script>
<style lang="scss" scoped>
.input-radio-with-bullets {
  display: flex;
  gap: 1.125rem;
  &--row {
    flex-wrap: wrap;
    flex-direction: row;
  }
  &--column {
    flex-direction: column;
  }
}

.input-radio-with-bullets .input-radio-with-bullets__input {
  opacity: 0;
  position: absolute;
  z-index: -1;
}

.input-radio-with-bullets .input-radio-with-bullets__title {
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  user-select: none;
}

.input-radio-with-bullets .input-radio-with-bullets__title::before {
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 50% 50%;
  border-radius: 50%;
  border: 1px solid var(--unfocus-color);
  content: "";
  display: inline-block;
  flex-grow: 0;
  flex-shrink: 0;
  height: 1.5rem;
  margin-right: 10px;
  width: 1.5rem;
}

.input-radio-with-bullets .input-radio-with-bullets__input:not(:disabled):not(:checked) +
.input-radio-with-bullets__title:hover::before {
  border: 1px solid var(--action-color);
}

.input-radio-with-bullets .input-radio-with-bullets__input:checked +
.input-radio-with-bullets__title::before {
  background-color: var(--action-color);
  border: 1px solid var(--action-color);
  box-shadow: inset 0 0 0 6px var(--primary-background-color);
}
</style>
